import { FC, ReactNode } from 'react';
import { FormCheck } from 'react-bootstrap';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import { FormCheckType } from 'types/common';

export interface SameDeliveryAndResidenceFormutil {
    same_delivery_and_residence: FormCheckType;
}

interface SameDeliveryAndResidenceProps extends FormGroupProps {
    disabled?: boolean;
    label?: ReactNode;
}

const SameDeliveryAndResidence: FC<SameDeliveryAndResidenceProps> = props => {
    const { label = __('My mailing address is different from my residential address'), disabled, ...restProps } = props;

    return (
        <FormGroup name="same_delivery_and_residence" $defaultValue="1" checked="0" unchecked="1" {...restProps}>
            <FormCheck inline type="checkbox" id="same_delivery_and_residence" label={label} disabled={disabled} />
        </FormGroup>
    );
};

export default SameDeliveryAndResidence;
